import { render, staticRenderFns } from "./AcaoFluxo.vue?vue&type=template&id=12d11998"
import script from "./AcaoFluxo.vue?vue&type=script&lang=js"
export * from "./AcaoFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports